import { Coordinate } from "rousen-react";
import api from "./api";

interface GetRouteRequest {
  origin: Coordinate;
  destination: Coordinate;
}

interface GetRouteResponse {
  hints: {
    "visited_nodes.sum": number;
    "visited_nodes.average": number;
  };
  info: {
    copyrights: string[];
  };
  id: number;
  paths: {
    ascend: number;
    bbox: number[];
    details: {};
    distance: number;
    time: number;
    points: {
      type: string;
      coordinates: [number, number][];
    };
  }[];
}

const routeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRoute: builder.query<GetRouteResponse["paths"][0], GetRouteRequest>({
      query: (request) => ({
        url: "route",
        method: "post",
        body: {
          ...request,
          key: "rGmu7q6z7Q2Os9sPbv0FvWbPCUUQ7ua+kH6QC8uCGa0=",
          type: "car",
        },
      }),
      transformResponse: (response: GetRouteResponse) => response.paths[0],
    }),
  }),
});

export default routeApi;
export const { useGetRouteQuery } = routeApi;
